export enum SocialMedia {
    FACEBOOK = "https://www.facebook.com/Publizm/",
    INSTAGRAM = "https://www.instagram.com/publizm/",
    YOUTUBE = "https://www.youtube.com/channel/UCcWIzvO9a9bc5xLRxlW0gkg",
    TIKTOK = "https://www.tiktok.com/@publizm",
}
